export class RecuManager {
  public date: number = 0;
  public libCaisse: string = "";
  public libSite: string = "";
  public id: string = "";
  public numRecu: string = "0";
  public numVendeur: number = 0;
  public libVendeur: string = "";
  public complements: Complement[] = new Array();
}

export class Complement {
  public cle: string = "NATURE";
  public type: string = "STRING";
  public valeur: string = "0";
  public id?: string = "0";
}
